import { render, staticRenderFns } from "./SettingHomePageDashboard.vue?vue&type=template&id=6629c54f&"
import script from "./SettingHomePageDashboard.vue?vue&type=script&lang=js&"
export * from "./SettingHomePageDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports